export default __webpack_public_path__ + "static/media/age.3b29c787.png";